/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Draft_Group_ChangesInputs */

const en_us2_draft_group_changes = /** @type {(inputs: Draft_Group_ChangesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 change`);
	return /** @type {LocalizedString} */ (`${i?.count} changes`)
	
};

const pt_br2_draft_group_changes = /** @type {(inputs: Draft_Group_ChangesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 mudança`);
	return /** @type {LocalizedString} */ (`${i?.count} mudanças`)
	
};

const es_419_draft_group_changes = /** @type {(inputs: Draft_Group_ChangesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 modificación`);
	return /** @type {LocalizedString} */ (`${i?.count} modificaciones`)
	
};

const pt_pt2_draft_group_changes = /** @type {(inputs: Draft_Group_ChangesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 alteração`);
	return /** @type {LocalizedString} */ (`${i?.count} alterações`)
	
};

const fr_fr2_draft_group_changes = /** @type {(inputs: Draft_Group_ChangesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 changement`);
	return /** @type {LocalizedString} */ (`${i?.count} changements`)
	
};

const de_de2_draft_group_changes = /** @type {(inputs: Draft_Group_ChangesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Änderung`);
	return /** @type {LocalizedString} */ (`${i?.count} Änderungen`)
	
};

const it_it2_draft_group_changes = /** @type {(inputs: Draft_Group_ChangesInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 modifica`);
	return /** @type {LocalizedString} */ (`${i?.count} modifiche`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 change" |
* | * | "{count} changes" |
*
* @param {Draft_Group_ChangesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_group_changes = /** @type {((inputs: Draft_Group_ChangesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Group_ChangesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_group_changes(inputs)
	if (locale === "es-419") return es_419_draft_group_changes(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_group_changes(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_group_changes(inputs)
	if (locale === "de-DE") return de_de2_draft_group_changes(inputs)
	if (locale === "it-IT") return it_it2_draft_group_changes(inputs)
	return en_us2_draft_group_changes(inputs)
});
export { draft_group_changes as "draft.group_changes" }